import "./index.scss";
import clsx from 'clsx';

import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Route, Switch, Link, NavLink, matchPath } from "react-router-dom";
import _ from "lodash";
import { getData } from "../../globalFunction";
import packageJson from '../../../package.json'
import constant from '../../../controller/utils/const';

import Sidebar from "./Sidebar/Sidebar";
import LogActivity from "./Modal/LogActivityTime/LogActivityTime";
import { NOTIFICATION_PATH } from "Source/routes";
import AddCompany from "../project/Company/components/AddCompany/AddCompany";
import Proceed from "../project/Company/components/Modal/Proceed/Proceed";
import Spinner from "../common/Elements/Spinner/Spinner";
import Icon from "../common/Elements/Icon/Icon";
import { Icons } from "@/src/assets/icons";
import { GIVE_FEEDBACK_URL } from "@/src/config";

import LookerReport from '../project/Dashboard/components/LookerReport/LookerReport';

import CookieConsentModal from "./CookieConsentModal/CookieConsentModal";
const Home = lazy(() => import("../home/Home"));
const Projects = lazy(() => import("../project"));
const Reports = lazy(() => import("../reports"));
const MyTasks = lazy(() => import("../myTasks2/MyTasks"));
const MyTimekeep = lazy(() => import("../myTimekeep"));
const MyConversations = lazy(() => import("../myConversations/MyConversations"));
const Users = lazy(() => import("../users"));
const Profile = lazy(() => import("../profile"));
const Developer = lazy(() => import("../developer"));
const Settings = lazy(() => import("../settings"));
const LegalInformationCenter = lazy(() => import("../legalInformationCenter"));
const notAvailable = lazy(() => import("../notAvailable"));
const inactiveProject = lazy(() => import("../inactiveProject"));
const error404 = lazy(() => import("../404"));
const NotificationsPopup = lazy(() => import("./Notifications/Notifications"));
const Notifications = lazy(() => import("../notification"));

let keyTimer = "";
const USER_TEAM = constant.USER_TEAM;
@connect(
    store => ({
        user: store.loggedUser.data,
        project: store.project,
        reminder: store.reminder,
        loggedUser: store.loggedUser,
        notification: store.notification,
        settings: store.settings,
        workstreams: store.workstreams,
        common: store.common,
        conversation: store.conversation,
        globalConfig: store.globalConfig
    }),
    null,
    (stateProps, dispatchProps, ownProps) => ({ ...stateProps, ...dispatchProps, ...ownProps })
)
class Main extends React.Component {
        componentDidMount() {
        const { dispatch } = this.props;
        try {
            getData('/api/me', {}, (response) => {
                if (response && response.data && response.status === 200 ) {
                    dispatch({ type: "SET_USER_PROJECTS", projects: response.data.projects });
                    dispatch({ type: "SET_USER_TYPE", userType: response.data["user-type"] });
                } else {
                    showToast('error', 'Failed to load user data.');
                }
            });
        } catch (err) {
            showToast('error', 'An error occurred while loading user data.');
        }
        // Remove all timeouts here
        }

    constructor(props) {
        super(props);
        this.state = {
            showLeft: true,
            showMore: "",
            reminderCount: 0,
            getReminder: true,
        };
        _.map(["showLeft", "handleAdd"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    showLeft() {
        const { dispatch, common } = this.props;

        dispatch({ type: "COMMON_UPDATE_SIDEPANEL_STATUS", status: common.sidepanelStatus === "default" ? "icon-only" : "default" })

    }
    UNSAFE_componentWillMount() {
        const { dispatch, user, location } = this.props;

        dispatch({ type: "UPDATE_SETTINGS", value: { app_version: packageJson.version } });

        getData(`/api/globalConfig`, {}, c => {
            if (c.data) {
                const group = _.groupBy(c.data.results, 'name')
                console.log("group", group)
                dispatch({ type: "SET_GLOBAL_CONFIG_LIST", global: group });
            }

        });

        if (window.innerHeight <= 550) {
            this.setState({ showMore: "" });
            $("body")
                .css("overflow-y", "auto")
                .css("min-height", "550px");
            $("html").scrollTop(0);
        } else {
            this.setState({ showMore: "bottom" });
        }
        $(window).resize(() => {
            if (window.innerHeight <= 550) {
                this.setState({ showMore: "" });
                $("#menu")
                    .css("overflow", "hidden")
                    .css("margin-top", "0px");
                $("body")
                    .css("overflow-y", "auto")
                    .css("min-height", "550px");
            } else {
                this.setState({ showMore: "bottom" });
                $("body")
                    .css("overflow-y", "")
                    .css("min-height", "");
                $("html").scrollTop(0);
            }
        });
    }

    setSideMenuState(status) {
        this.setState({ miniSideMenu: status });
        setCookie("sidemenu", status, 1);
    }

    setShowMore(type) {
        if (type === "top") {
            $("#menu")
                .css("overflow", "hidden")
                .css("margin-top", "-" + (window.innerHeight < 767 ? 767 - window.innerHeight : 0) + "px");
        } else {
            $("#menu")
                .css("overflow", "hidden")
                .css("margin-top", "0px");
        }
        this.setState({ showMore: type });
    }

    handleAdd(type) {
        const { dispatch, history, location } = this.props;
        let formType = "";
        let selectedType = "";
        const id = Math.floor(Math.random() * 11);
        switch (type) {
            case "task":

                if (location.pathname !== "/my-tasks") {
                    dispatch({ type: "CLEAR_TASKS_DATA" });
                    history.push(`/my-tasks?action=add`);
                } else {
                    $('#task-form').modal('show')
                }

                selectedType = "SET_TASK_SELECTED";
                break;
            case "company":
                dispatch({ type: 'SET_PROJECT_ADD_TYPE', addType: type });
                $("#addCompanyModal").modal("show");

                break;
            case "project":
                dispatch({ type: 'SET_PROJECT_ADD_TYPE', addType: type });
                $("#addCompanyModal").modal("show");

                break;
            case "user":
                if (location.pathname !== USER_TEAM) {
                    history.push(USER_TEAM + '?action=add');
                } else {
                    $("#addNewUsersTeams").modal("show");
                }

                formType = "SET_USER_FORM_ACTIVE";
                selectedType = "SET_USER_SELECTED";
                break;

        }

        // dispatch({ type: formType, FormActive: "Form" });
        dispatch({ type: selectedType, Selected: {} });

    }

    render() {
        const { showLeft } = this.state;
        const { project, loggedUser, settings, workstreams, conversation } = this.props;
        const { avatar } = loggedUser.data;
        let pages = [
            {
                label: "My Dashboard",
                icon: "fa-home",
                path_name: "",
                component: Home,
                exact: true,
                show_menu: true,
                isAvailable: true
            },
            {
                label: "My Tasks",
                icon: "fa-list",
                path_name: "my-tasks",
                component: MyTasks,
                show_menu: true,
                isAvailable: true
            },
            {
                label: "My Timekeep",
                icon: "fa-list",
                path_name: "my-timekeep",
                component: MyTimekeep,
                show_menu: loggedUser.data.userRole < 5,
                isAvailable: loggedUser.data.userRole < 5
            },
            {
                label: "My Conversations",
                icon: "fa-comments",
                path_name: "my-conversations",
                component: MyConversations,
                show_menu: true,
                isAvailable: true
            },
            {
                label: "Users",
                icon: "fa-users",
                path_name: "users",
                component: Users,
                show_menu: loggedUser.data.userRole < 4,
                isAvailable: loggedUser.data.userRole < 4
            },
            {
                label: "Projects",
                icon: "fa-calendar",
                path_name: "projects",
                component: Projects,
                show_menu: true,
                isAvailable: true
            },
            {
                label: "Reports",
                icon: "fa-calendar",
                path_name: "reports",
                component: Reports,
                show_menu: loggedUser.data.userRole <= 4,
                isAvailable: loggedUser.data.userRole <= 4
            },
            {
                label: "Developer",
                icon: "fa-code",
                path_name: "developer",
                component: Developer,
                show_menu: loggedUser.data.userRole < 3,
                isAvailable: loggedUser.data.userRole < 3
            },
            {
                label: "Settings",
                icon: "fa-cog",
                path_name: "settings",
                component: Settings,
                show_menu: loggedUser.data.userRole < 3,
                isAvailable: loggedUser.data.userRole < 3
            },
            {
                label: "Legal Information Center",
                path_name: "legal-information-center",
                component: LegalInformationCenter,
                show_menu: true,
                isAvailable: true
            },
            {
                label: "My Account",
                path_name: "profile",
                component: Profile,
                show_menu: false,
                isAvailable: true
            },
            {
                label: "",
                path_name: "not-found",
                component: notAvailable,
                isAvailable: true
            },
            // {
            //     label: "Notification",
            //     path_name: "notification",
            //     component: Notification,
            //     show_menu: false,
            //     isAvailable: true
            // },
            {
                label: "",
                path_name: "inactive-project",
                component: inactiveProject,
                show_menu: false,
                isAvailable: true
            }, {
                label: "",
                path_name: "404",
                component: error404,
                show_menu: false,
                isAvailable: true
            },
            {
                label: "All Updates",
                path_name: "notifications",
                component: Notifications,
                show_menu: false,
                isAvailable: true,
                exact: true,
            }
        ];
        let dropdownAddLinks = [{ id: "task", label: "Task" }, { id: "company", label: "Company" }, { id: "project", label: "Project" }, { id: "user", label: "User" }];
        if (loggedUser.data.userRole > 3) {
            dropdownAddLinks = [{ id: "task", label: "Task" }, { id: "project", label: "Project" }];
        }

        if (loggedUser.data.userType === "External") {
            pages = _.filter(pages, ({ path_name }) => {
                return path_name !== "users";
            });
        }

        const currentPath = this.props.location.pathname;
        const parentPath = currentPath.split("/")[1];
        const currentPage = _.find(pages, page => {
            return page.path_name === parentPath;
        });

        const getProjectDetailsPath = currentPath.split("/");
        const currentProjectPage = typeof getProjectDetailsPath[3] === "undefined" ? "dashboard" : getProjectDetailsPath[3];
        const label = project.Type === 'company' ? 'Company List' : 'Project List'
        const path = window.location.href.replace(/^.*[\\\/]/, '')
        let header = currentPage?.label !== "Projects" ? currentPage.label : path === 'projects' ? label : ''
        const inactive = path === 'inactive-project'
        const hasInactiveData = localStorage.getItem('inactive_project') ? JSON.parse(localStorage.getItem('inactive_project')) : null
        let projectPic = project.Selected.picture
        if (!header && inactive && hasInactiveData) {
            header = hasInactiveData.project
            projectPic = hasInactiveData.picture
        }

        return (
            <>
                <div class={showLeft ? "flex-row" : ""} id="main-container">
                    <Sidebar history={this.props.history} />
                    <Suspense fallback={<Spinner />}>
                        <div class={`flex-col content-div ${`sidepanel-${this.props.common.sidepanelStatus}`}`}>
                            <div class={(this.state.miniSideMenu === "true" ? "sidebar-left-mini" : "") + ""} id="wrap">
                                <header class="head">
                                    <div id="main-nav-bar" class="main-bar">
                                        <div class="mainHeaderActions">
                                            <div class="siderbar-toggle">
                                                <a onClick={this.showLeft}>
                                                    {this.props.common.sidepanelStatus === "default" && <i class="material-icons">chevron_left</i>}
                                                    <i class="material-icons">menu</i>
                                                    {this.props.common.sidepanelStatus !== "default" && <i class="material-icons">chevron_right</i>}
                                                </a>
                                            </div>
                                            {inactive && <div class="project-title-wrapper ml10"><img src={`/api/file/project_pictures/${projectPic}`} alt="Project Picture" class="img-responsive" /></div>}
                                            <div class="title item">{_.isEmpty(currentPage) === false && header && <h3 style={{ textTransform: "capitalize", marginTop: 0, marginBottom: 0 }}>{header}</h3>}</div>
                                            {(getProjectDetailsPath[2] === String(project.Selected.id) && typeof project.Selected.id !== "undefined") && (
                                                <div class="project-title-wrapper">
                                                    <NavLink to={`/projects/${project.Selected.id + "/settings"}`}>
                                                        <img src={`/api/file/project_pictures/${projectPic}`} alt="Project Picture" class="img-responsive" />
                                                        <strong>{project.Selected.project}</strong>
                                                    </NavLink>
                                                </div>
                                            )}
                                            <div class="action item">
                                                <div class="hidden-sm hidden-xs text-center display-flex action-link" id="bell">
                                                    {loggedUser.data.userType === "External" ?
                                                        <a class="btn feedBackButton" type="button" href={GIVE_FEEDBACK_URL} target="_blank" >
                                                            <Icon>{Icons.Megaphone}</Icon>
                                                            <p>Give Feedback</p>
                                                        </a>
                                                        : (
                                                            <div class="generalBtnActions">
                                                                <a class="btn btn-default dropdown-toggle generalAddBtn" type="button" id="new" data-toggle="dropdown">
                                                                    <i class="material-icons">add</i>
                                                                </a>
                                                                <div class="pull-right dropdown-menu generalAddDropdown" role="menu" aria-labelledby="new">
                                                                    <ul>
                                                                        <li>
                                                                            <a>
                                                                                Add New...
                                                                            </a>
                                                                        </li>
                                                                        {_.map(dropdownAddLinks, ({ id, label }, index) => {
                                                                            return (
                                                                                <li role="presentation" key={index}>
                                                                                    <a role="menuitem" onClick={(e) => { e.preventDefault(); this.handleAdd(id) }}>
                                                                                        {label}
                                                                                    </a>
                                                                                </li>
                                                                            );
                                                                        })}
                                                                    </ul>
                                                                </div>

                                                                <a class="btn generalAddTimelog" type="button" onClick={(e) => { e.preventDefault(); $(`#logActivityTimeModal`).modal("show"); }}> <i class="material-icons">schedule</i></a>
                                                            </div>
                                                        )}
                                                    {this.props.location.pathname !== NOTIFICATION_PATH && (
                                                        <NotificationsPopup />
                                                    )}
                                                    <Link to={"/profile"}>
                                                        <div class="menu-profile">
                                                            <img src={`/api/file/profile_pictures/${avatar}`} alt="Profile Picture" class="img-responsive" />
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </header>
                                <div id="content" class={`${currentPage.path_name} ${currentProjectPage} ${currentProjectPage === "workstreams" ? `workstream_${workstreams.pageType}` : ""} ${header === 'Company List' || header === 'Project List' ? `projectListContainer` : ""}`}>
                                    <Switch>
                                        {_.map(pages, (page, index) => {
                                            if (page.isAvailable) {
                                                return <Route exact={typeof page.exact !== "undefined" ? page.exact : false} path={`/${page.path_name}`} component={page.component} key={index} />;
                                            }

                                            return null;
                                        })}
                                        <Route component={notAvailable} />
                                    </Switch>
                                </div>
                                <AddCompany />
                                <Proceed history={this.props.history} projectId={project.Selected.id} />
                                <LogActivity />
                                <CookieConsentModal />
                            </div>
                        </div>
                    </Suspense>
                </div>
            </>
        );
    }
}

export default withRouter(Main);